import { debounce, insertAfter, replaceFieldvalue, replaceStringByPrefix, wrapEl } from '../shared/utilities';

import * as b2c from './self-asserted.dom';
import { b2cPage, isB2cDemo } from "./b2c";

import { setupPasswordTogglers } from "../shared/password-toggler";
import { hideEl, showEl } from "../shared/visibility-toggler";
import { authTemplate } from "./auth";
import { observeDom, observeDomDisconnect } from "../shared/observer";


/**
 * Switch step
 *
 * @param targetStep
 */
export function switchStep(targetStep) {
    const stepPrefix = `${authTemplate.id}--step-`;

    if (targetStep === 0) {
        authTemplate.classList.add(`${stepPrefix}0`);
    } else {
        authTemplate.className = replaceStringByPrefix(authTemplate.className, stepPrefix, targetStep);
    }

    /* Trigger template specific page logic */
    switch(b2cPage) {
        case 'sign-up':
            initSignUp(targetStep);
            break;
        case 'reset-password':
            if(b2c.emailField) {
                initResetPasswordCheck(targetStep);
            } else {
                initResetPassword(targetStep);
            }
            break;
    }
}


export function initSignUp(targetStep) {
    selfAssertedEmail(targetStep);
    selfAssertedVerificationCode(targetStep);
    selfAssertedPassword(targetStep);
    selfAssertedMFA(targetStep);
    selfAssertedDisplayName(targetStep);
    selfAssertedCtaButtons(targetStep);
}

export function initResetPasswordCheck(targetStep) {
    selfAssertedEmail(targetStep);
    selfAssertedVerificationCode(targetStep);
    selfAssertedCtaButtons(targetStep);
}

export function initResetPassword(targetStep) {
    selfAssertedPassword(targetStep);
}


/**
 * Initialize SelfAsserted template logic
 */
export function initSelfAsserted() {
    /* Separate preparation(step 0) logic from step 1 logic */
    switchStep(0);
    switchStep(1);
}


/**
 * Email logic
 *
 * @param step
 */
export function selfAssertedEmail(step) {
    switch (step) {
        case 1:
            hideEl(b2c.emailFieldEditButton);
            break;
        case 2:
            if(isB2cDemo) {
                b2c.emailField.setAttribute('disabled', 'true');
                b2c.emailField.value = 'dev@test.me';
            }

            /* Set readonly email field */
            showEl(b2c.emailFieldEditButton);
            hideEl(b2c.emailField);

            b2c.emailFieldlabel.removeAttribute('for');
            b2c.emailFieldReadOnly.innerText = b2c.emailField.value;

            b2c.emailFieldEditButton.classList.add('show');
            showEl(b2c.emailFieldReadOnly);

            break;
        case 3:
            break;
        default:
            b2c.emailField.setAttribute('placeholder', '');

            b2c.emailFieldWrapper.classList.add('email-field-wrapper', 'form-control-wrapper');
            b2c.emailFieldWrapper.setAttribute('id', 'email-field-wrapper');

            b2c.emailFieldReadOnly.classList.add('email-field-readonly');
            b2c.emailFieldReadOnly.setAttribute('id', 'email-field-readonly');

            /* Manipulate dom */
            insertAfter(b2c.emailField, b2c.emailFieldReadOnly);
            wrapEl(b2c.emailFieldReadOnly, b2c.emailFieldWrapper);
            b2c.emailFieldWrapper.appendChild(b2c.emailFieldEditButton);
            insertAfter(b2c.emailFieldWrapper, b2c.emailFieldErrorFormat);

            /* Reload page and restart flow to change email */
            b2c.emailFieldEditButton.addEventListener('click', function () {
                location.reload();
            });
    }
}


/**
 * Password logic
 *
 * @param step
 */
export function selfAssertedPassword(step) {
    const passwordChooseWrapper = b2c.passwordChooseField.closest('li');
    const passwordConfirmWrapper = b2c.passwordConfirmField.closest('li');

    switch (step) {
        case 1:
            break;
        case 2:
            break;
        case 3:
            if (b2cPage === 'sign-up') {
                showEl(passwordChooseWrapper);
                showEl(passwordConfirmWrapper);
            }
            break;
        default:
            b2c.passwordChooseField.setAttribute('placeholder', '');
            b2c.passwordConfirmField.setAttribute('placeholder', '');

            if (b2cPage === 'sign-up') {
                hideEl(passwordChooseWrapper);
                hideEl(passwordConfirmWrapper);
            }

            /* TODO: setup togglers for reset-password page (listen for insertion of password fields in mutation observer) */
            /* TODO: add password toggle triggers without wrapping the password field (this destroys B2C validation messages toggle logic for this field somehow) */
            //setupPasswordTogglers();
    }
}


/**
 * MFA logic
 *
 * @param step
 */
export function selfAssertedMFA(step) {
    if (b2c.mfaField === null) { return; }
    const mfaFieldWrapper = b2c.mfaField.closest('li');

    switch (step) {
        case 1:
            break;
        case 2:
            break;
        case 3:
            if (b2cPage === 'sign-up') {
                showEl(mfaFieldWrapper);
            }
            break;
        default:
            if (b2cPage === 'sign-up') {
                hideEl(mfaFieldWrapper);
                b2c.fieldList.appendChild(mfaFieldWrapper);
            }
    }
}



/**
 * Verification code logic
 * @param step
 */
export function selfAssertedVerificationCode(step) {
    const verificationButtons = b2c.verificationSendButton.closest('.buttons.verify');

    switch (step) {
        case 1:
            b2c.verificationSendButton.addEventListener('click', function () {
                if (!b2c.emailField.classList.contains('invalid')) {
                    switchStep(2);
                }
            });

            break;
        case 2:
            if (b2cPage === 'sign-up' || b2cPage === 'reset-password') {
                const observeVerificationSuccessConfig = {
                    attributes: true
                };

                showEl(b2c.verificationCodeHelp);
                observeDom(b2c.verificationFieldSuccess, observeVerificationSuccessConfig, observeVerificationSuccess);

                if(isB2cDemo) {
                    b2c.verificationCodeVerifyButton.addEventListener('click', function () {
                        b2c.verificationFieldSuccess.setAttribute('aria-hidden', 'false');
                    });
                }

                function observeVerificationSuccess(mutations, observer) {
                    if (b2c.verificationFieldSuccess.getAttribute('aria-hidden') === 'false') {
                        switchStep(3);
                        observeDomDisconnect(observer, observeVerificationSuccess);
                    }
                }
            }

            if(isB2cDemo) {
                hideEl(b2c.verificationSendButton);
                showEl(b2c.verificationCodeLabel);
                showEl(b2c.verificationCodeField);
                showEl(b2c.verificationCodeVerifyButton);
                showEl(b2c.verificationCodeResendButton);
            }
            break;
        case 3:
            hideEl(verificationButtons);
            hideEl(b2c.verificationCodeLabel);
            hideEl(b2c.verificationCodeHelp);
            break;
        default:
            b2c.verificationCodeField.addEventListener('paste', function (e) {
                replaceFieldvalue(e, /\D/, 'g');
            }, false);

            const processInput = debounce((e) => {
                e.target.value = e.target.value.replace(/\D/g, '');
            }, 250);

            b2c.verificationCodeField.addEventListener('input', function (e) {
                processInput(e);
            }, false);

            b2c.verificationCodeResendButton.addEventListener('click', function () {
                b2c.verificationCodeField.value = '';
                b2c.verificationCodeField.focus();
            });


            /**
             * Dom changes
             */
            b2c.verificationCodeField.setAttribute('placeholder', '123456');
            b2c.verificationCodeField.setAttribute('autocomplete', 'nope');
            b2c.verificationCodeField.setAttribute('maxlength', '6');

            /* Wrapper */
            b2c.verificationCodeFieldWrapper.classList.add('verification-field-wrapper', 'form-control-wrapper');
            b2c.verificationCodeFieldWrapper.setAttribute('id', 'verification-field-wrapper');
            wrapEl(b2c.verificationCodeField, b2c.verificationCodeFieldWrapper);
            insertAfter(b2c.emailFieldWrapper, b2c.verificationFieldErrorServer);

            /* Move help text */
            hideEl(b2c.verificationCodeHelp);
            insertAfter(b2c.verificationCodeLabel, b2c.verificationCodeHelp);

            /* Move errors */
            insertAfter(b2c.verificationCodeFieldWrapper, b2c.verificationFieldErrorRetry);
            insertAfter(b2c.verificationCodeFieldWrapper, b2c.verificationFieldErrorNoRetry);
            insertAfter(b2c.verificationCodeFieldWrapper, b2c.verificationFieldErrorThrottled);
            insertAfter(b2c.verificationCodeFieldWrapper, b2c.verificationFieldErrorCodeExpired);
    }
}


/**
 * Display name logic
 *
 * @param step
 */
export function selfAssertedDisplayName(step) {
    switch (step) {
        case 1:
            break;
        case 2:
            break;
        case 3:
            if (b2cPage === 'sign-up') {
                showEl(b2c.displayNameField.closest('li'));
            }
            break;
        default:
            /* Remove placeholder */
            b2c.displayNameField.setAttribute('placeholder', '');

            const displayNameWrapper = b2c.displayNameField.closest('li');
            insertAfter(b2c.emailFieldWrapper.closest('li'), displayNameWrapper);

            hideEl(displayNameWrapper);
    }
}


/**
 * CTA buttons logic
 *
 * @param step
 */
export function selfAssertedCtaButtons(step) {
    const ctaButtons = b2c.createAccountButton.closest('.buttons');

    switch (step) {
        case 1:
            break;
        case 2:
            break;
        case 3:
            showEl(ctaButtons);

            if(isB2cDemo) {
                b2c.createAccountButton.addEventListener('click', function () {
                    window.location.href = 'account-linked.html';
                });
            }

            break;
        default:
            hideEl(ctaButtons);
    }
}
